import { voteAlert } from '../../utils/voteAlert';

export function sortByAdmited(beds, language) {
  return beds.sort((a, b) => {
    // sort by device and patient name
    if (
      a.patient &&
      a.patient.devices &&
      a.patient.devices.length === 0 &&
      b.patient &&
      b.patient.devices &&
      b.patient.devices.length > 0
    )
      return 1;
    else if (
      a.patient &&
      a.patient.devices &&
      a.patient.devices.length > 0 &&
      b.patient &&
      b.patient.devices &&
      b.patient.devices.length === 0
    )
      return -1;
    else if (
      a.patient &&
      a.patient.devices &&
      a.patient.devices.length > 0 &&
      b.patient &&
      b.patient.devices &&
      b.patient.devices.length > 0
    ) {
      let firstnameA = getFirstname(language, a.patient);
      let firstnameB = getFirstname(language, b.patient);
      return firstnameA.toUpperCase().localeCompare(firstnameB.toUpperCase(), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    }

    // sort by admit status
    const firstnameA = a.patient ? getFirstname(language, a.patient) : null;
    const firstnameB = b.patient ? getFirstname(language, b.patient) : null;
    if (firstnameA === null && firstnameB) return 1;
    else if (firstnameA && firstnameB === null) return -1;
    else if (firstnameA && firstnameB) {
      return firstnameA.toUpperCase().localeCompare(firstnameB.toUpperCase(), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    }

    // sort by room name
    let nameA = a.roomName + '/' + a.name;
    let nameB = b.roomName + '/' + b.name;
    return nameA.toUpperCase().localeCompare(nameB.toUpperCase(), undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });
}

export function sortByPriorityOld(beds, language) {
  return beds.sort((a, b) => {
    // find alertTime minimum from A
    const votedAlertA = voteAlert(a.patient);
    const minAlertTimeA = votedAlertA && votedAlertA.votedAlert ? votedAlertA.votedAlert.alertTime : undefined;

    // find alertTime minimum from B
    const votedAlertB = voteAlert(b.patient);
    const minAlertTimeB = votedAlertB && votedAlertB.votedAlert ? votedAlertB.votedAlert.alertTime : undefined;

    if (minAlertTimeA === undefined && minAlertTimeB) return 1;
    else if (minAlertTimeA && minAlertTimeB === undefined) return -1;
    else if (minAlertTimeA && minAlertTimeB) {
      let alertA = minAlertTimeA;
      let alertB = minAlertTimeB;

      if (alertA > alertB) return 1;
      else if (alertA < alertB) return -1;
      return 0;
    }

    // sort by device and patient name //
    if (
      a.patient &&
      a.patient.devices &&
      a.patient.devices.length === 0 &&
      b.patient &&
      b.patient.devices &&
      b.patient.devices.length > 0
    )
      return 1;
    else if (
      a.patient &&
      a.patient.devices &&
      a.patient.devices.length > 0 &&
      b.patient &&
      b.patient.devices &&
      b.patient.devices.length === 0
    )
      return -1;
    else if (
      a.patient &&
      a.patient.devices &&
      a.patient.devices.length > 0 &&
      b.patient &&
      b.patient.devices &&
      b.patient.devices.length > 0
    ) {
      let firstnameA = getFirstname(language, a.patient);
      let firstnameB = getFirstname(language, b.patient);
      return firstnameA.toUpperCase().localeCompare(firstnameB.toUpperCase(), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    }

    // sort by admit status
    const firstnameA = a.patient ? getFirstname(language, a.patient) : null;
    const firstnameB = b.patient ? getFirstname(language, b.patient) : null;
    if (firstnameA === null && firstnameB) return 1;
    else if (firstnameA && firstnameB === null) return -1;
    else if (firstnameA && firstnameB) {
      return firstnameA.toUpperCase().localeCompare(firstnameB.toUpperCase(), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    }

    // sort by room name
    let nameA = a.roomName + '/' + a.name;
    let nameB = b.roomName + '/' + b.name;
    return nameA.toUpperCase().localeCompare(nameB.toUpperCase(), undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });
}

export function sortByPriorityNew(beds, language) {
  return beds.sort((a, b) => {
    // find alertTime minimum from A
    const votedAlertA = voteAlert(a.patient);
    const maxAlertTimeA = votedAlertA && votedAlertA.votedAlert ? votedAlertA.votedAlert.alertTime : undefined;
    // const alertsOfPatientA = a.patient && a.patient.devices ? a.patient.devices.map(d => d.action ? d.action['alertTime'] : null).filter(d => d) : [];
    // const maxAlertTimeA = alertsOfPatientA.length > 0 ? Math.max(...alertsOfPatientA) : undefined;

    // find alertTime minimum from B
    const votedAlertB = voteAlert(b.patient);
    const maxAlertTimeB = votedAlertB && votedAlertB.votedAlert ? votedAlertB.votedAlert.alertTime : undefined;
    // const alertsOfPatientB = b.patient && b.patient.devices ? b.patient.devices.map(d => d.action ? d.action['alertTime'] : null).filter(d => d) : [];
    // const maxAlertTimeB = alertsOfPatientB.length > 0 ? Math.max(...alertsOfPatientB) : undefined;

    if (maxAlertTimeA === undefined && maxAlertTimeB) return 1;
    else if (maxAlertTimeA && maxAlertTimeB === undefined) return -1;
    else if (maxAlertTimeA && maxAlertTimeB) {
      let alertA = maxAlertTimeA;
      let alertB = maxAlertTimeB;

      if (alertA > alertB) return -1;
      else if (alertA < alertB) return 1;
      return 0;
    }

    // sort by device and patient name
    if (
      a.patient &&
      a.patient.devices &&
      a.patient.devices.length === 0 &&
      b.patient &&
      b.patient.devices &&
      b.patient.devices.length > 0
    )
      return 1;
    else if (
      a.patient &&
      a.patient.devices &&
      a.patient.devices.length > 0 &&
      b.patient &&
      b.patient.devices &&
      b.patient.devices.length === 0
    )
      return -1;
    else if (
      a.patient &&
      a.patient.devices &&
      a.patient.devices.length > 0 &&
      b.patient &&
      b.patient.devices &&
      b.patient.devices.length > 0
    ) {
      let firstnameA = getFirstname(language, a.patient);
      let firstnameB = getFirstname(language, b.patient);
      return firstnameA.toUpperCase().localeCompare(firstnameB.toUpperCase(), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    }

    // sort by admit status
    const firstnameA = a.patient ? getFirstname(language, a.patient) : null;
    const firstnameB = b.patient ? getFirstname(language, b.patient) : null;
    if (firstnameA === null && firstnameB) return 1;
    else if (firstnameA && firstnameB === null) return -1;
    else if (firstnameA && firstnameB) {
      return firstnameA.toUpperCase().localeCompare(firstnameB.toUpperCase(), undefined, {
        numeric: true,
        sensitivity: 'base',
      });
    }

    // sort by room name
    let nameA = a.roomName + '/' + a.name;
    let nameB = b.roomName + '/' + b.name;
    return nameA.toUpperCase().localeCompare(nameB.toUpperCase(), undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });
}

export function sortByRoom(beds) {
  return beds.sort((a, b) => {
    let nameA = a.roomName + '/' + a.name;
    let nameB = b.roomName + '/' + b.name;
    nameA = nameA.toUpperCase();
    nameB = nameB.toUpperCase();
    return nameA.localeCompare(nameB, undefined, {
      numeric: true,
      sensitivity: 'base',
    });
  });
}

export function sortListmanage(beds, isHospital, language) {
  return isHospital ? sortByRoom(beds) : sortByAdmited(beds, language);
}

export function sortFixedEmergency(data) {
  const FixedEmergencyData = data;
  if (FixedEmergencyData.length > 0) {
    FixedEmergencyData.sort((a, b) => {
      return new Date(b.date) - new Date(a.date);
    });
    // FixedEmergencyData.forEach((d) => {
    //   (d.notifications || []).sort((a, b) => {
    //     const alertA = a.alerts.find((alert) => alert.alertTime);
    //     const alertB = b.alerts.find((alert) => alert.alertTime);
    //     if (alertA && alertB) {
    //       const alertTimeA = alertA.alertTime;
    //       const alertTimeB = alertB.alertTime;

    //       if (alertTimeA > alertTimeB) return -1;
    //       else if (alertTimeA < alertTimeB) return 1;
    //       return 0;
    //     }
    //   });
    // });
    FixedEmergencyData.forEach((d) => {
      (d.notifications || []).sort((a, b) => {
        const getFirstAlertTime = (notification) => {
          const alert = notification.alerts.find((alert) => alert.alertTime);
          return alert ? alert.alertTime : null;
        };
    
        const alertTimeA = getFirstAlertTime(a);
        const alertTimeB = getFirstAlertTime(b);
    
        if (alertTimeA && alertTimeB) {
          return alertTimeB - alertTimeA;
        }
    
        return 0;
      });
    });
  }
  return FixedEmergencyData;
}

const getFirstname = (language, data) => {
  let firstname = '';
  if (language && language === 'th-TH') {
    if (data.firstname) {
      firstname = data.firstname;
    } else {
      firstname = data.firstnameEn;
    }
  }
  if (language && language === 'en-EN') {
    if (data.firstnameEn) {
      firstname = data.firstnameEn;
    } else {
      firstname = data.firstname;
    }
  }
  return firstname;
};
